module.exports = __webpack_public_path__ + "4a08307d.svg";